import { Window } from './src/utils'

export { wrapRootElement } from './src/gatsby/wrap-wroot-element'

export const onRouteUpdate = ({ location, prevLocation }) => {
  if (Window) {
    window.ccLayer = window.ccLayer || []
    window.ccLayer.push({
      ccEvent: 'pageViewed',
      src: 'custom',
    })
    Window.scrollTo(0, 0)
  }
}
